module.exports = __webpack_public_path__ + "static/media/shop.69cf67a3.png";